import { useEffect, useState } from 'react';
/**
 * Hook that returns the current network online status
 * Uses the native web navigator.onLine API
 */
export const useIsOnline = () => {
    const [isOnline, setIsOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
    useEffect(() => {
        // Only run in browser environment
        if (typeof window === 'undefined' || typeof navigator === 'undefined') {
            return;
        }
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
        // Add event listeners
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        // Cleanup event listeners
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
    return isOnline;
};
export default useIsOnline;
